const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'AeBar',
  props: {
    data: {
      type: Array,
      default: () => [
        { id: 1, name: '站点1', value: 18, color: '' },
        { id: 2, name: '站点2', value: 85, color: '' },
        { id: 3, name: '站点3', value: 67, color: '' },
        { id: 4, name: '站点4', value: 32, color: '' },
        { id: 5, name: '站点5', value: 21, color: '' },
        { id: 6, name: '站点6', value: 45, color: '' },

        { id: 7, name: '站点7', value: 18, color: '' },
        { id: 8, name: '站点8', value: 85, color: '' },
        { id: 9, name: '站点9', value: 67, color: '' },
        { id: 10, name: '站点10', value: 32, color: '' },
        { id: 11, name: '站点11', value: 21, color: '' },
        { id: 12, name: '站点12', value: 45, color: '' },
        { id: 13, name: '站点13', value: 18, color: '' },
        { id: 14, name: '站点14', value: 85, color: '' },
        { id: 15, name: '站点15', value: 67, color: '' },
        { id: 16, name: '站点16', value: 32, color: '' },
        { id: 17, name: '站点17', value: 21, color: '' },
        { id: 18, name: '站点18', value: 45, color: '' },
        { id: 19, name: '站点19', value: 18, color: '' },
        { id: 20, name: '站点20', value: 85, color: '' },
        { id: 21, name: '站点21', value: 67, color: '' },
        { id: 22, name: '站点22', value: 32, color: '' },
        { id: 23, name: '站点23', value: 21, color: '' },
        { id: 24, name: '站点24', value: 45, color: '' },
      ]
    },
    type: { type: String, default: () => 'bar' },
    barWidth: { type: String | Number, default: () => '20' },
    cols: { type: String | Number, default: () => '' },
    color: { type: String, default: () => '#aaa' },
    fontSize: { type: String | Number, default: () => '12' },
    textStyle: { type: Object, default: () => ({}) },
    itemStyle: { type: Object, default: () => ({}) },
    scrollOption: { type: Object, default: () => ({ height: 20 }) },
    backgroundColor: { type: String, default: () => 'rgba(0, 0, 0, 0)' },
  },
  data() {
    return {
      option: {},
      styles: {
        textStyle: {
          color: this.color,
          fontSize: parseInt(this.fontSize),
          ...this.textStyle,
        },
      },
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.create();
      }
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const labels = this.data.length > 0 && this.data.map(a => (a.name || a.label || a.title || '匿名'));
      const values = this.data.length > 0 && this.data.map((a, b) => ({
        name: a.name || a.text || a.label || a.title || '匿名',
        value: a.data || a.code || a.value || a.number || null,
        itemStyle: {
          color: a.color || null,
          borderWidth: a.borderWidth || 10,
          ...this.itemStyle,
        },
        animationDelay: c => c * b * 100,
        ...a,
      }));
      this.option = ({
        backgroundColor: this.backgroundColor,
        grid: {
          show: false,
          top: Math.ceil(this.fontSize / 2),
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
          ...this.styles,
        },
        xAxis: {
          show: true,
          type: 'category',
          data: labels,
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            ...this.styles,
          },
        },
        yAxis: {
          show: true,
          splitLine: {
            show: false,
          },
          nameLocation: 'start',
          axisLabel: {
            ...this.styles,
          },
        },
        series: [
          { type: this.type, data: values, barWidth: parseInt(this.barWidth) },
        ],
        dataZoom: this.cols && (this.data.length > parseInt(this.cols) && ([
          {
            show: true,
            type: 'slider',
            orient: 'horizontal',
            xAxisIndex: [0],
            zoomLock: true,
            startValue: 0,
            maxValueSpan: (parseInt(this.cols) - 1),
            ...this.scrollOption
          },
          { type: 'inside', xAxisIndex: [0], zoomOnMouseWheel: false, moveOnMouseMove: true, moveOnMouseWheel: true },
        ])),
      });
    },
  },
  render() {
    const { option = {}, delay = 600, ...attrs } = this.$attrs;
    return (<Aecharts option={{ ...this.option, ...option }} delay={delay} {...{ attrs }} />);
  }
}